export default __webpack_public_path__ + "static/media/company_header.43e112bb.jpg";